import { Box, Typography, Collapse } from '@mui/material';
import { useContext, useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { LocalOffer } from '@mui/icons-material';
import ExpandOrCollapseButton from 'components/buttons/icons/expand-or-collapse';
import { GlobalTypesContext } from 'context/global-types-context';
import { ProjectPermissionContext } from 'context/project-permission-context';
import Tags from 'routes/parameters-page/common/tags';
import DataDrawerGrid from 'routes/parameters-page/common/grid';
import useProjectDetails from '../hooks/use-project-details';
import useAssetDetails from '../hooks/use-asset-details';

const ParameterListTags = () => {
  const { assetTagsAndTypes } = useContext(GlobalTypesContext);
  const { writePermission } = useContext(ProjectPermissionContext);
  const { assetId, projectId } = useParams();
  const { assetTags, setAssetTags, isTagLoading } = useAssetDetails();
  const {
    projectTags,
    isTagLoading: isProjectTagLoading,
    setProjectTags,
  } = useProjectDetails();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [assetId]);

  const contentRef = useRef(null);

  useEffect(() => {
    if (open && contentRef.current) {
      setTimeout(() => {
        contentRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 100);
    }
  }, [open]);

  return (
    <DataDrawerGrid
      icon={<LocalOffer />}
      caption={'Tags'}
      content={
        <Box aria-label="tags component" width="auto" ref={contentRef}>
          <ExpandOrCollapseButton
            buttonSize="small"
            open={open}
            onClick={() => {
              setOpen(!open);
            }}
            sx={theme => ({
              marginLeft: theme.spacing(-1.5),
            })}
          />
          <Typography variant="caption" display="inline" color="textSecondary">
            {assetId ? 'Asset Tags' : 'Project Tags'}
          </Typography>
          <Collapse in={open}>
            {assetTagsAndTypes.map(tagType => (
              <Tags
                referenceTable={assetId ? 'assets' : 'project'}
                id={assetId ? assetId : projectId}
                existingTags={assetId ? assetTags : projectTags}
                setExistingTags={assetId ? setAssetTags : setProjectTags}
                tagType={tagType}
                globalTags={tagType?.tags}
                key={tagType?.id}
                loading={assetId ? isTagLoading : isProjectTagLoading}
                permission={writePermission}
              />
            ))}
          </Collapse>
        </Box>
      }
    />
  );
};

export default ParameterListTags;
